export default "__VITE_ASSET__DZFnyJsB__"